/*eslint no-use-before-define:0 *///TODO REMOVE THIS
let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let _ = require('ES/lib/lodash');
let esUtils = require('ES/utils/esUtils');
let RadioMixin = require('ES/utils/RadioMixin');
let DayPopover = require('./DayPopover');
let CalendarTools = require('./CalendarTools');
let HoverMixin = require('ES/utils/HoverMixin');
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let build_month_calendar = function (year, month, calendar_data) {
  let days_data = {};
  if (calendar_data && calendar_data.calendar && calendar_data.calendar[year.toString()] && calendar_data.calendar[year.toString()][month.toString()]) {
    days_data = calendar_data.calendar[year.toString()][month.toString()];
  }
  return _.map(esUtils.build_calendar_weeks(year, month), function (week) {
    return _.map(week, function (day) {
      if (day.out_of_month) {
        return day;
      }
      day.events = [];
      if (days_data[day.date]) {
        let detail_ids = days_data[day.date].detail_ids;
        if (detail_ids && calendar_data.details) {
          _.each(detail_ids, function (id) {
            if (calendar_data.details[id]) {
              day.events.push(calendar_data.details[id]);
            }
          });
        }
      }
      return day;
    });
  });
};

module.exports = dd.createClass({
  __incMonth: function (inc) {
    let d = new Date(this.props.year, this.props.month - 1, 1);
    d.setMonth(d.getMonth() + inc);
    radio('Show_Calendar').broadcast('month', d);
  },
  __prevMonth: esUtils.wrapPreventDefault(function () {
    this.__incMonth(-1);
  }),
  __nextMonth: esUtils.wrapPreventDefault(function () {
    this.__incMonth(1);
  }),
  __today: esUtils.wrapPreventDefault((function () {
    let d1 = new Date(this.props.year, this.props.month - 1, 1);
    let d2 = new Date();
    this.__incMonth(d2.getMonth() - d1.getMonth() + (12*(d2.getFullYear() - d1.getFullYear())));
  })),
  __yearView: esUtils.wrapPreventDefault(function () {
    radio('Show_Calendar').broadcast('year');
  }),
  render: function () {
    let month = this.props.month;
    let year = this.props.year;
    const Displaylists = this.props.Displaylists;

    let month_weeks = build_month_calendar(year, month, this.props.Calendars[year]);
    return dd.table({className: 'MonthCalendar'},
      dd.thead(null,
        dd.tr(null,
          dd.th({colSpan: 7, className: 'month-and-year forward-backward-picker'},
            dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginLeft: "0"}, onClick: this.__nextMonth},
              dd.i({className: 'fa fa-angle-right'})
            ),
            dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginLeft: "0", marginRight: "0"}, onClick: this.__today},
              "today"
            ),
            dd.button({className: 'pull-right btn btn-default btn-sm', style: {marginRight: "0"}, onClick: this.__prevMonth},
              dd.i({className: 'fa fa-angle-left'})
            ),
            dd.span({className: 'title'},
              esUtils.get_month_name(month) + ' ', dd.a({href: '#', onClick: this.__yearView}, year)
            ),
            dd.div({className: 'clearfix'})
          )
        ),
        dd.tr(null,
          _.map([1, 2, 3, 4, 5, 6, 7], function (d) {
            return dd.th({key: d}, esUtils.get_day_of_week(d));
          })
        )
      ),
      dd.tbody(null,
        _.map(month_weeks, function (week, i) {
          return dd.tr({key: i},
            _.map(week, function (day, i) {
              return CalendarDay({key: i, year: year, month: month, day: day, Displaylists});
            })
          );
        })
      )
    );
  }
});

let CalendarDay = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {show_popover: false};
  },
  componentWillMount: function () {
    let self = this;
    self.radio = {
      MiniCalendar_day_clicked: function (year, month, day) {
        let s_year = self.props.year;
        let s_month = self.props.month;
        let s_day = self.props.day && self.props.day.date;
        let s_out_of_month = self.props.day && self.props.day.out_of_month;
        let show = (year === s_year) && (month === s_month) && (day === s_day) && !s_out_of_month;

        if (show !== self.state.show_popover) {//only do this if there is a change
          setTimeout(function () {//need to run them outside of each others update phase
            self.setState({show_popover: show});
          }, 1);
        }
      },
      MiniCalendar_close_all_popovers: function () {
        if (self.state.show_popover) {
          self.setState({show_popover: false});
        }
      }
    };
  },
  __clickDay: esUtils.wrapPreventDefault(function () {
    let day = this.props.day;
    radio('MiniCalendar_day_clicked').broadcast(this.props.year, this.props.month, day.date);
  }),
  __click_newEvent: esUtils.wrapPreventDefault(function () {
    let day = this.props.day;
    let month = this.props.month;
    let year = this.props.year;
    this.setState({show_popover: false}, function () {
      radio('Hashbang_set').broadcast('/events/new' + (!day ? '' : '/' + year + '-' + month + '-' + day.date));
    });
  }),
  render: function () {
    let day = this.props.day;
    const Displaylists = this.props.Displaylists;

    let events = _.uniq(day.events, CalendarTools.getEventHash);
    return dd.td({className: day.out_of_month ? 'out-of-month' : null},
      dd.div({
          className: 'date clickable text-right ' + (day.eventstatus || ''), onClick: this.__clickDay, style: {
            position: "relative"
          }
        },
        day.date,
        this.state.show_popover ? DayPopover({
          items: [{name: 'Create new', onClick: this.__click_newEvent}],
          width_factor: 1
        }) : null
      ),
      _.map(_.sortBy(events, CalendarTools.getEventClass).reverse(), function (event, i) {
        return CalendarEvent({key: i, event: event, Displaylists});
      })
    );
  }
});

let CalendarEvent = dd.createClass({
  mixins: [HoverMixin],
  render: function () {
    let event = this.props.event;
    const Displaylists = this.props.Displaylists;
    let has_other_company = false;

    let url = CalendarTools.getEventURL(event);
    let text = CalendarTools.getEventText(event);

    //events belonging to other companies get special treatment
    if (!_.include(_.get(AuthedUserSession, ["activeCompanyIds"]), _.parseInt(event.cmpid))) {
      text = _.get(Displaylists, "universal.company", []).find(obj => {
        return obj.id === event.cmpid;
      });

      text = "[" + _.get(text, "abbr", ("COMPANY " + event.cmpid)) + "] ";

      let location = (_.get(event, "vcty", "") + " " + _.get(event, "vst", "")).trim();
      if (location === '') {
        // if location is blank (i.e. no city or state), then use the country instead
        location = _.get(event, "vcnt", "").trim();
      }
      if (location === '' || location === 'US') {
        // if the location is still blank, then just use the description
        location = 'TBD';
      }
      //name = (company + personal + location).trim();
      text = (text + location).trim();

      url = null;
      has_other_company = true;
    }

    //add speakername
    let speakernames = _.map(event.sids, function (sid) {
      let r = _.findWhere(_.get(Displaylists, "perspeaker", []), {'sid': _.parseInt(sid, 10)});
      r = _.get(r, 'name_last', '');
      return r;
    });
    text += " (" + speakernames.join(",") + ")";

    return dd.div({
        style: {position: 'relative'}
      },
      dd[url ? 'a' : 'span']({
          href: url,
          className: 'event ' + CalendarTools.getEventClass(event) + (has_other_company ? ' othercompany' : ''),
          onMouseEnter: this.hoverable_onMouseEnter,
          onMouseLeave: this.hoverable_onMouseLeave
        },
        CalendarTools.getEventIcon(event), ' ', text
      ),
      this.state.hover ? dd.div({
          ref: "hoverable",
          className: "tooltip top",
          role: "tooltip",
          style: {
            position: "fixed",
            opacity: 1,
            top: this.state.hoverable_top + 'px',
            left: this.state.hoverable_left + 'px'
          }
        },
        dd.div({className: "tooltip-arrow"}),
        dd.div({className: "tooltip-inner"}, text)
      ) : null
    );
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/MonthCalendar.js